// Transform raw JWT claims into a UserProfile (used server-side and client-side).
export const getUserObject = (claims) => {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        customerId: claims["https://auth.dtn.com/customerId"],
        requesterIp: claims["https://auth.dtn.com/requesterIp"],
        availableApps: claims["https://auth.dtn.com/availApps"],
        appInfo: claims["https://auth.dtn.com/appInfo"],
        email: claims.email,
        emailVerified: claims.email_verified,
        updatedAt: claims.updated_at,
        id: claims.sub.replace("auth0|", ""),
        name: claims.name,
        first_name: claims.given_name,
        last_name: claims.family_name,
    };
};
